import React from 'react';
import { PageContent } from '../components';
import { colors } from 'constants/colors';
import { uberSmall, reFormat } from 'utils';
import { FlexContainerCentered, FlexContainer } from 'components/flex';
import { LazyLoadImage } from 'features/LazyImage';
import { HtmlComponent } from 'features/HtmlComponent';
import OPE from 'components/common/EpiOnPageEdit';
import { UnderlineContainer, UnderlineContainerText } from 'components/UnderlineContainer';
import Breadcrumbs from 'components/breadcrumbs';
import { Title, MainBody, Strong, Title2 } from 'components/text';
import { InlineLinkWithIcon, InlineWithIcon, InlineLink } from 'components/link';
import phoneIcon from 'images/chat-icon.svg';
import officeIcon from 'images/house-icon.svg';
import mailIcon from 'images/mail-icon.svg';
import mapIcon from 'images/map-marker-icon.svg';
import Map from 'features/Map';
import { getSelectedFromSelectionProperty } from 'utils';

export const ContactPage = ({
  image,
  header,
  localOffice,
  mainBody,
  organization,
  phone,
  secondPhone,
  email,
  postadress,
  title,
  visitingAdress,
  kontorsplats,
  breadcrumbs
}) => {
  const htmlComponentStyles = {};
  const selectedLocalOffice = getSelectedFromSelectionProperty(localOffice);
  const secondPhoneInfo = {
    href: `tel:${secondPhone}`,
    value: secondPhone
  };

  let selectedKontorsplats = '';
  if (kontorsplats != null) {
    selectedKontorsplats = JSON.parse(kontorsplats[0].officePageData);
  }
  const info = [
    {
      icon: officeIcon,
      name: 'Lokalkontor',
      value: kontorsplats != null ? selectedKontorsplats.header : selectedLocalOffice,
      href: kontorsplats != null ? selectedKontorsplats.officePageUrl : null
    },
    {
      icon: phoneIcon,
      href: `tel:${phone}`,
      name: 'Telefon',
      value: phone
    },
    {
      icon: mailIcon,
      href: `mailto:${email}`,
      name: 'E-post',
      value: email
    },
    {
      margin: 0,
      icon: mapIcon,
      name: 'Postadress',
      value: postadress
    },
    {
      name: 'Besöksadress',
      value: visitingAdress
    }
  ];

  let coordinatesList = [];

  if (kontorsplats != null) {
    const json = kontorsplats.map(office => JSON.parse(office.officePageData));

    json.forEach(office => {
      coordinatesList.push({ latitude: office.latitude, longitude: office.longitude });
    });
  }

  return (
    <FlexContainerCentered>
      <PageContent bottommargin>
        {breadcrumbs && <Breadcrumbs breadcrumbs={breadcrumbs} margin="1em auto 0 0" />}
        <UnderlineContainer position="bottom" color={colors.ORANGE}>
          <OPE propertyName="type">
            <UnderlineContainerText>Kontakt</UnderlineContainerText>
          </OPE>
        </UnderlineContainer>
        <OPE propertyName="header">
          <Title style={{ width: '100%' }} margin="0 0 0.4167rem 0" black>
            {header}
          </Title>
        </OPE>
        <OPE propertyName="title">
          <Title2 color={colors.LIGHT_GRAY} margin="0 0 1.875rem 0">
            {title}
          </Title2>
        </OPE>
        <FlexContainer row margin="0 0 1.25rem 0">
          <div style={{ marginRight: 'auto' }}>
            <LazyLoadImage
              width={'5.833rem'}
              placeholder={uberSmall(image)}
              src={reFormat(image)}
            />
          </div>
          <FlexContainer
            column
            margin="0 0 0 2rem"
            smallmargin="1rem 0 0 0"
            justifycontent="flex-start">
            {info.map(({ name, icon, href, value, margin = '0.5rem' }) => {
              if (name === 'Telefon' && secondPhone != null) {
                return (
                  <MainBody fontsize14onsmall key={`${name}_${value}`} margin={`0 0 ${margin} 0`}>
                    {href && (
                      <InlineLinkWithIcon large icon={icon} href={href}>
                        <Strong>{name}:</Strong>
                        {` ${value}`}
                        <InlineLink large href={secondPhoneInfo.href}>
                          , {` ${secondPhoneInfo.value}`}
                        </InlineLink>
                      </InlineLinkWithIcon>
                    )}
                    {!href && (
                      <InlineWithIcon large icon={icon}>
                        <Strong>{name}:</Strong>
                        {` ${value}`}
                      </InlineWithIcon>
                    )}
                  </MainBody>
                );
              }

              return (
                <MainBody fontsize14onsmall key={`${name}_${value}`} margin={`0 0 ${margin} 0`}>
                  {href && (
                    <InlineLinkWithIcon large icon={icon} href={href}>
                      <Strong>{name}:</Strong>
                      {` ${value}`}
                    </InlineLinkWithIcon>
                  )}
                  {!href && (
                    <InlineWithIcon large icon={icon}>
                      <Strong>{name}:</Strong>
                      {` ${value}`}
                    </InlineWithIcon>
                  )}
                </MainBody>
              );
            })}
          </FlexContainer>
        </FlexContainer>
        <HtmlComponent style={htmlComponentStyles} html={mainBody} />
        {kontorsplats != null ? (
          <OPE propertyName="map">
            {kontorsplats &&
              coordinatesList[0].latitude !== '0' &&
              coordinatesList[0].longitude !== '0' && (
                <Map coordinatesList={[coordinatesList[0]]} height={300} width={'100%'} zoom={14} />
              )}
          </OPE>
        ) : (
          <></>
        )}
      </PageContent>
    </FlexContainerCentered>
  );
};
